import { Typography } from '@mui/material';
import React, { Component } from 'react';
import Basic from '../../container/layouts/Basic';
import Notif from '../common/Notif';
import EmployeeDemandList from '../EmployeeView/EmployeeDemandList';

class UserDemands extends Component {
    state = {  
        notif: {
            openNotif: false,
            variant:"",
            message: "",
        },
    }
    notif = (variant, message) => {
        console.log('==================NOTIF==================');
        console.log(variant, message);
        console.log('====================================');
        this.setState({
            notif:{
                openNotif: true,
                variant,
                message
            }
        })
    }
    handleCloseNotif = () => {
        this.setState({ 
            notif: {
                openNotif: false,
                variant:"",
                message: "",
            }
        });
    };
    render() {
        const { openNotif, variant, message} = this.state.notif;
        return (
            <Basic demands {...this.props}>
                {openNotif && variant && message &&
                    <Notif open={true} {...this.state.notif} onClose={this.handleCloseNotif} />
                }
                <Typography variant="h4">Demandes</Typography>
                <EmployeeDemandList {...this.props} notif={this.notif}/>
            </Basic>
        );
    }
}

export default UserDemands;